import React, { useState, useRef } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../constants/Languages';

import chevronDownAccent from '../../../assets/icons/chevron-down-accent.svg'
import chevronUpAccent from '../../../assets/icons/chevron-up-accent.svg';

const Dropdown = ({ clang, label, dropdownListData }) => {
	const [ isOpen, setIsOpen ] = useState(false);
	const dropdownRef = useRef(null);

	const getDropdownClosed = (e) => {
		if (dropdownRef.current && isOpen && !dropdownRef.current.contains(e.target)) {
			setIsOpen(false)
		}
	};

	document.addEventListener('mousedown', getDropdownClosed);

	return (
		<div
			ref={ dropdownRef }
			className="dropdown__container"
			role="dropdown"
		>
			<button
				onClick={ () => setIsOpen(!isOpen) }
				className="dropdown__button"
				aria-haspopup="true"
				aria-controls="dropdown-list"
			>
				{ label }
				{ !isOpen ?
					<img
						src={ chevronDownAccent }
						alt={ lang[ clang ].alt.chevron_down }
					/>
					:
					<img
						src={ chevronUpAccent }
						alt={ lang[ clang ].alt.chevron_up }
					/>
				}
			</button>
			{ isOpen &&
				<ul
					className="dropdown__list"
					id="dropdown-list"
				>
					{ dropdownListData.map((item) => {
						return (
							<li
								key={ `${item.id}` }
								className="dropdown__list--item"
								role="menu-item"
								tabIndex="0"
							>
								<a
									target="_blank"
									href={ item.href }
								>
									{ item.label }
								</a>
							</li>
						)
					}) }
				</ul> }
		</div>
	);
};

Dropdown.propTypes = {
	clang: propTypes.string.isRequired,
	label: propTypes.string,
	dropdownListData: propTypes.any,
};

const mapStateToProps = state => ({
	clang: state.language.currentLanguage,
});

export default connect(mapStateToProps)(Dropdown);






// WEBPACK FOOTER //
// ./src/components/ui/Dropdown/Dropdown.js